module.exports = "<div>\n  <ion-spinner name=\"dots\"></ion-spinner>\n</div>"